export const $programas: { [key: string]: string } = {
  "nomiEscritorio": "NomiExpress Escritorio",
  "nomiWeb": "NomiExpress Web",
  "contpaq": "Contpaq Nomi",
  "aspel": "Aspel",
  "runa": "Runa",
  "nomilinea": "Nomilinea",
  "apsi": "Apsi",
}
